export const getFromLocalStorage = (name, parsingSkip) => {
	const item = localStorage.getItem(name)
	if (item) return parsingSkip ? item : JSON.parse(item)
	return null
}
